document.addEventListener('DOMContentLoaded', () => {
    // Create GSAP timeline
    const tlhpshaft = gsap.timeline({
        scrollTrigger: {
            trigger: ".kg-img-wrap-intro", 
            start: "top 80%", 
            end: "bottom bottom", 
            toggleActions: "play none none none", 
        }
    });

    // Animate the image with a 1-second fade-in duration
    tlhpshaft.fromTo(".kg-shaft-img-cont img", {
        opacity: 0
    }, {
        x: 0,
        opacity: 1,
        duration: 1,
        delay: 0,
        ease: 'power1.in'
    });
});
